// extracted by mini-css-extract-plugin
export default {"footerLink":"FooterColumn_footerLink__rud1u"};